import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.helpers.getContactDisplayNameByIntegrationCode', {
    customer: 'Customer',
    supplier: 'Supplier',
    vendor: 'Vendor',
    contact: 'Contact',
});
